import CryptoJS from 'crypto-js'

type typeCrypto = 'encrypt' | 'decrypt'

export const encryptData = (data: string, type: typeCrypto): string => {
	const secretKey = process.env.REACT_APP_SECRET_KEY
	if (secretKey) {
		// encrypt
		if (type === 'encrypt' && secretKey) {
			const cifrado = CryptoJS.AES.encrypt(data, secretKey).toString()
			return cifrado
		}
		// decrypt
		try {
			const bytes = CryptoJS.AES.decrypt(data, secretKey)
			if (bytes.sigBytes <= 0) {
				return ''
			}
			const textoDescifrado = bytes.toString(CryptoJS.enc.Utf8)
			if (!textoDescifrado) {
				return ''
			}
			return textoDescifrado
		} catch (error) {
			console.warn('Failed to decrypt data:', error)
			return ''
		}
	}
	return 'An error occurred'
}
